// extracted by mini-css-extract-plugin
export default {"arrow":"ReturnButton_arrow__f-FD8"};